<body class="grid-container">
    <app-layout-header class="header"></app-layout-header>
    <app-layout-menu class="mt-2"></app-layout-menu>
    <div class="p-col p-ai-center p-jc-center bams-body-content">
        <router-outlet></router-outlet>
    </div>
    <app-layout-footer class="footer"> </app-layout-footer>
</body>